$.fn.dataTable.ext.type.order['date-pre'] = (date) -> date

$.fn.dataTable.Editor.fieldTypes.datetime.get = (conf) ->
    picker = conf._input.data 'DateTimePicker'
    return picker.date()
